import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

// Componentes


import { OnlyNumberDirective } from '../../components/directives/number.directive';
import { OnlyDecimalDirective } from '../../components/directives/decimal.directive';

@NgModule({
    declarations: [


      OnlyNumberDirective,
      OnlyDecimalDirective,

    ],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      BsDatepickerModule,
      PopoverModule,
      TooltipModule,
      SweetAlert2Module,
      BsDropdownModule.forRoot()
    ],
    exports: [


      OnlyNumberDirective,
      OnlyDecimalDirective,

    ]
})
export class SharedModule { }

